import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from '../hooks/ThemeContext';
import { api } from '../services/baseUrl';
import LoadingSpinner from '../components/globals/LoadingSpinner';
import SectionTitle from '../components/common/SectionTitle';

const Checkout = () => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === 'dark';
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleStripeCheckout = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await api.post('/payment/create-checkout-session', {
        shipping_address: null,
        billing_address: null,
      });

      if (response.data?.success && response.data?.session_url) {
        window.location.href = response.data.session_url;
        return;
      }

      setError(response.data?.message || 'Impossible de démarrer le paiement');
    } catch (err) {
      const message = err.response?.data?.message || err.message || 'Erreur paiement';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`flex-1 flex flex-col ${isDark ? 'bg-[#0f1114] text-white' : 'bg-slate-50 text-gray-800'}`}>
      <div className="container mx-auto px-4 py-12 max-w-3xl">
        <SectionTitle
          title="Paiement"
          subtitle="Test Stripe - redirection vers la page de paiement sécurisée"
          align="left"
        />

        {error && (
          <div className={`p-4 rounded-lg mb-6 ${isDark ? 'bg-red-500/20 text-red-300 border border-red-500/30' : 'bg-red-50 text-red-800 border border-red-200'}`}>
            {error}
          </div>
        )}

        <div className={`p-6 rounded-lg ${isDark ? 'bg-[#0b0b0c] border border-white/6' : 'bg-white border border-gray-100'}`}>
          <p className={`text-sm mb-6 ${isDark ? 'text-white/70' : 'text-gray-600'}`}>
            Ce test utilise Stripe Checkout en mode test. Vous serez redirigé vers Stripe pour finaliser le paiement.
          </p>

          <div className="flex gap-3">
            <button
              onClick={handleStripeCheckout}
              disabled={loading}
              className="px-5 py-3 rounded-lg bg-rose-600 text-white font-medium hover:bg-rose-700 transition-colors disabled:opacity-50"
            >
              {loading ? 'Redirection...' : 'Lancer le test de paiement'}
            </button>
            <button
              onClick={() => navigate('/cart')}
              className={`px-5 py-3 rounded-lg border font-medium transition-colors ${
                isDark
                  ? 'border-white/20 text-white hover:bg-white/10'
                  : 'border-gray-300 text-gray-800 hover:bg-gray-50'
              }`}
            >
              Retour au panier
            </button>
          </div>

          {loading && (
            <div className="mt-6">
              <LoadingSpinner />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Checkout;
